import { Controller } from "stimulus"

export default class GalleryController extends Controller {
  connect() {
    this.onScroll()
  }

  onScroll() {
    const st = window.pageYOffset
    if (
      document.documentElement.scrollHeight - st - parseInt(document.querySelector("footer").offsetHeight) <=
      window.innerHeight
    ) {
      const photoNodes = document.querySelectorAll(".photos a.photo:not(.masonry)")
      for (var i = 0; i < 20; i++) {
        if (photoNodes[i]) {
          photoNodes[i].classList.add("masonry")
          this.showPhoto(photoNodes[i])
        }
      }
      this.onResize()
    }
  }

  onResize() {
    const photos = document.querySelector(".photos-wrapper")
    const photosWidth = photos.offsetWidth
    const photoNodes = Array.from(document.querySelectorAll(".photos a.photo.masonry"))
    var h = 0
    var w = document.querySelector(".photos a.photo").offsetWidth
    var cols = Math.round(photosWidth / w)

    photoNodes.forEach((photo, i) => {
      photo.style.left = `${(i % cols) * w}px`
      photo.style.top =
        i >= cols ? `${photoNodes[i - cols].offsetTop + photoNodes[i - cols].offsetHeight + 32}px` : "0px"

      if (photo.offsetTop + photo.offsetHeight > h) {
        h = photo.offsetTop + photo.offsetHeight
      }
    })

    photos.style.height = `${h}px`
  }

  showPhoto(el) {
    const img = el.querySelector("img")

    img.addEventListener("load", () => {
      el.classList.add("show")
      this.onResize()
    })
    img.addEventListener("error", () => {
      el.classList.add("show")
    })

    img.src = img.getAttribute("data-img-original")
  }
}
